import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { CircularProgress, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { CollectorSettingsResult } from 'graphql/types';

type CollectorsLoadMoreProps = {
  loading: boolean;
  collectorSettingsResult: CollectorSettingsResult;
  loadMore: (cursor: string) => void;
};

const useStyles = makeStyles((theme) => ({
  loading: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    padding: theme.spacing(1, 0)
  },
  loadingText: {
    paddingLeft: theme.spacing(1)
  }
}));

export const CollectorsLoadMore: React.FC<CollectorsLoadMoreProps> = ({
  loading,
  collectorSettingsResult,
  loadMore
}: CollectorsLoadMoreProps) => {
  const classes = useStyles();
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    setHasMore(Boolean(collectorSettingsResult.cursor));
  }, [collectorSettingsResult.cursor]);

  const onLoadMore = useCallback(() => {
    if (collectorSettingsResult.cursor) {
      loadMore(collectorSettingsResult.cursor);
    } else {
      setHasMore(false);
    }
  }, [loadMore, collectorSettingsResult.cursor]);

  const [sentryRef] = useInfiniteScroll({
    loading: loading,
    hasNextPage: hasMore,
    onLoadMore: onLoadMore,
    rootMargin: '0px 0px 600px 0px'
  });

  return hasMore ? (
    <div
      ref={sentryRef}
      className={classes.loading}
      data-testid="collectors-inifinite-scroll-loading"
    >
      <CircularProgress size={18} />
      <Typography variant="body2" className={classes.loadingText}>
        <FormattedMessage id="smartDiary.loading" />
      </Typography>
    </div>
  ) : (
    <></>
  );
};
